import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const styles = tv({
	slots: {
		base: 'py-4 md:pt-[10rem] lg:pb-[11.5rem] bg-black',
		inner: '2xl:max-w-[172rem] 2xl:mx-auto px-2 md:px-4',
		header: 'lg:flex lg:w-full lg:flex-row lg:justify-between lg:items-end',
		heading: 'text-center lg:text-left self-center',
		stepsContainer: 'mt-5 lg:hidden',
		stepsDesktop: 'hidden lg:inline-flex lg:justify-center lg:relative lg:w-[65rem]',
	},
})

export type SchemaSectionVariants = VariantProps<typeof styles>
